import { CalendarDate } from "@internationalized/date";
/* ===== Month helpers (column layout only — no business math) ===== */
export const MONTH_ABBR = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const monthGroupLabel = (month, year) => `${MONTH_ABBR[month - 1]}-${year}`;
export const monthValueLabel = (month, year) => `${MONTH_ABBR[month - 1]}-${String(year).slice(2)}`;
// Months shown: Jan..current for this year, all 12 for past years, or a single picked month.
export const getMonthsToShow = (year, selectedMonth) => {
    if (selectedMonth)
        return [selectedMonth];
    const now = new Date();
    const lastMonth = year === now.getFullYear() ? now.getMonth() + 1 : 12;
    return Array.from({ length: lastMonth }, (_, i) => i + 1);
};
export const isCurrentMonth = (year, month) => {
    const now = new Date();
    return year === now.getFullYear() && month === now.getMonth() + 1;
};
// A month strictly before the current one — the only months whose BDR legacy data is editable.
export const isPastMonth = (year, month) => {
    const now = new Date();
    return year < now.getFullYear() || (year === now.getFullYear() && month < now.getMonth() + 1);
};
/* ===== Dates (deal drawer) ===== */
export const toCalendarDate = (iso) => {
    if (!iso)
        return null;
    const d = new Date(iso);
    if (isNaN(d.getTime()))
        return null;
    return new CalendarDate(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate());
};
export const fromCalendarDate = (date) => {
    if (!date)
        return "";
    return `${date.year}-${String(date.month).padStart(2, "0")}-${String(date.day).padStart(2, "0")}`;
};
export const formatDealDate = (iso) => {
    if (!iso)
        return "-";
    const d = new Date(iso);
    if (isNaN(d.getTime()))
        return "-";
    return `${String(d.getUTCMonth() + 1).padStart(2, "0")}/${String(d.getUTCDate()).padStart(2, "0")}/${d.getUTCFullYear()}`;
};
